import React, { useState } from 'react';
import Sidebar from './Sidebar';
import Header from './Header';


const Layout = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  const handleMenuClick = () => {
    const isDesktop = window.innerWidth >= 1024;
    if (isDesktop) {
      setSidebarCollapsed(!sidebarCollapsed);
    } else {
      setSidebarOpen(!sidebarOpen);
    }
  };

  return (
    <div className="layout-wrapper">
      <Sidebar  isOpen={sidebarOpen}  setIsOpen={setSidebarOpen} isCollapsed={sidebarCollapsed}/>
      <div className={`layout-main ${sidebarCollapsed ? 'sidebar-collapsed' : ''}`}>
        <Header onMenuClick={handleMenuClick} />
        <main className="layout-content">
          <div className="layout-content-inner"> {children}</div>
        </main>
      </div>
    </div>
  );
};

export default Layout;